import React from 'react';
import s from '../CreateInvoice.module.css';
import searchIcon from '../../../assets/img/icons/akar-icons_search.svg';

interface Props {
	value: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const SearchByNameInput: React.FC<Props> = ({value, onChange}) => {
	return (
		<div className={s.searchInput}>
			<input
				onChange={onChange}
				value={value}
				type="text"
				placeholder={'Комплекс Омега +'}
			/>
			<button type={'button'}>
				<img src={searchIcon} alt="searchIcon" />
			</button>
		</div>
	);
};

export default SearchByNameInput;
